import { useState } from "react";
import { motion } from "framer-motion";
import { Loader2, MessageCircle } from "lucide-react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

export const CodeVerifyStep = ({ state, onVerify, busy, error }) => {
  const [code, setCode] = useState("");
  const cr = state.code_request;
  const blocked = cr.status === "BLOQUEADO";
  const submit = (e) => { e.preventDefault(); if (code.length === 6) onVerify(code, () => setCode("")); };

  return (
    <motion.form onSubmit={submit} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="glass-card w-full max-w-xl p-8 text-center sm:p-10" data-testid="code-verify-step">
      <MessageCircle className="mx-auto h-12 w-12" style={{ color: "var(--brand)" }} />
      <h1 className="mt-6 font-display text-2xl text-slate-50 sm:text-3xl">Confirme seu código</h1>
      <p className="mt-4 text-slate-300" data-testid="code-verify-message">
        Você receberá um código de 6 dígitos no seu WhatsApp (final {cr.phone_hint}). Digite-o abaixo para confirmar.
      </p>
      <div className="mt-8 flex justify-center">
        <InputOTP maxLength={6} value={code} onChange={(v) => setCode(v.replace(/\D/g, ""))} disabled={blocked || busy} inputMode="numeric" data-testid="code-verify-input">
          <InputOTPGroup>
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <InputOTPSlot key={i} index={i} className="h-14 w-11 border-white/15 bg-black/30 font-mono-x text-xl text-slate-50 sm:w-12" />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </div>
      {error && <p className="mt-3 text-sm text-red-400" data-testid="code-verify-error">{error}</p>}
      {!error && cr.rejected && <p className="mt-3 text-sm text-red-400" data-testid="code-verify-rejected">Não foi possível validar o código. Verifique e envie novamente.</p>}
      {!blocked && cr.attempts > 0 && <p className="mt-2 text-xs text-slate-500">Tentativas restantes: {cr.max_attempts - cr.attempts}</p>}
      <button type="submit" disabled={blocked || busy || code.length !== 6} className="btn-gold mt-8 h-12 w-full" data-testid="code-verify-submit">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Confirmar código"}
      </button>
      <p className="mt-4 text-xs text-slate-500">Nunca compartilhe senhas bancárias ou dados de cartão. Este código serve apenas para confirmar seu atendimento.</p>
    </motion.form>
  );
};
